const contactForms = document.querySelectorAll("[data-contact-form]");
class FormsValidation {
    constructor() {
        this.checkFormValidity = (arrayOfRequiredElements) => {
            let errorCounter = 0;
            if (arrayOfRequiredElements && arrayOfRequiredElements.length > 0) {
                arrayOfRequiredElements.forEach((item) => {
                    if (item.hasAttribute("required")) {
                        const isValidItem = item.checkValidity();
                        //handle checkbox
                        if (item.type === "checkbox") {
                            const label = item.parentElement.querySelector("label");
                            if (isValidItem) {
                                label.classList.remove('error');
                            }
                            else {
                                label.classList.add('error');
                                errorCounter++;
                            }
                            //all other inputs
                        }
                        else {
                            if (isValidItem) {
                                item.classList.remove('error');
                            }
                            else {
                                item.classList.add('error');
                                errorCounter++;
                            }
                        }
                        item.addEventListener("click", () => {
                            item.classList.remove('error');
                        });
                    }
                });
                return errorCounter > 0 ? false : true;
            }
        };
        this.temporaryDisableButton = (button) => {
            if (button) {
                button.disabled = true;
                setTimeout(() => {
                    button.removeAttribute("disabled");
                }, 2000);
            }
        };
        this.initFormsValidation = () => {
            if (contactForms && contactForms.length > 0) {
                let isFormValid = false;
                contactForms && contactForms.forEach((form) => {
                    const submitButton = form.querySelector("[submit-button]");
                    submitButton.addEventListener("click", (e) => {
                        e.preventDefault();
                        // set active form
                        contactForms.forEach((singleForm) => singleForm.removeAttribute("data-active-form"));
                        form.setAttribute("data-active-form", "true");
                        // disable button
                        this.temporaryDisableButton(submitButton);
                        // check form validity
                        const contactFormRequiredElements = form.querySelectorAll("[required]:not([disabled])");
                        if (contactFormRequiredElements && contactFormRequiredElements.length > 0) {
                            isFormValid = this.checkFormValidity(contactFormRequiredElements);
                            if (isFormValid) {
                                if (isRecaptchaEnabled) {
                                    grecaptcha.execute(parseInt(form.getAttribute("g-recaptcha-index")));
                                }
                                else {
                                    form.submit();
                                }
                            }
                        }
                    });
                });
            }
        };
    }
}
